<template lang="html">
  <div id="catalog-form-page">

    <section class="container oversized-container main-section">
      <div class="row pt-4">
        <div class="col pl-sm-0 col-link">
          <router-link class="link-back" to="/inicio"><i class="fal fa-chevron-left icon"></i> <span>Regresar</span></router-link>
        </div>

        <div class="col col-titles col-mid">
          <h1>ISR por pago de Aguinaldo</h1>
          <hr />
        </div>

        <div class="col col-empty"></div>
      </div>

      <div class="row justify-content-center">

        <!-- Paso 1, Form -->
        <div class="col-12 col-mid col-form" v-if="step == 1">
          <h5 class="mb-4 title">DATOS GENERALES</h5>

          <b-form @submit="onSubmit">
            <b-form-group class="custom-form-group-s2"
              label="Año a consultar:"
              label-for="i-anio">
              <b-form-select class="blacked" v-model="form.anio" required oninvalid="this.setCustomValidity('Selecciona una opción')" oninput="setCustomValidity('')">
                  <b-form-select-option :value="null" disabled selected>Año</b-form-select-option>
                  <b-form-select-option :value="year.value" v-for="(year, yindx) in years" :key="yindx">{{year.value}}</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Aguinaldo a pagar:"
              label-for="i-agui" id="input-aguinaldo">
              <currency-input id="i-agui" class="form-control"
                v-model="form.aguinaldo" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.aguinaldo != null" style="color: red;"><small>{{validation.aguinaldo}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Salario mensual ordinario:"
              label-for="i-sala" id="input-salario">
              <currency-input id="i-sala" class="form-control"
                v-model="form.salario" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.salario != null" style="color: red;"><small>{{validation.salario}}</small></div>
            </b-form-group>

            <p class="mt-3 mt-lg-5 pt-sm-4 text-center">
              <b-button type="submit" class="_btn-st1 btn-orange" id="btn_calc">Calcular</b-button>
            </p>
          </b-form>
        </div>
        <!-- Paso 1, FIN -->

        <!-- Paso 2, Mostrar datos -->
        <div class="col-12 col-mid col-results" v-if="step == 2">
          <h5 class="title">DATOS GENERALES</h5>

          <div class="row">
            <div class="col-12 col-line">
              <hr />
            </div>

            <div class="col-12 col-subbox">
              <div class="row align-items-center">
                <div class="col col-text">
                  <h2 class="trans-250 title with-link" @click="scrolltoTable">CONSULTAR FUNDAMENTOS LEGALES <i class="fas fa-info-circle icon"></i></h2>
                </div>

                <!--div class="col col-share">
                  <a class="btn-share" v-b-modal.modal-compartir>Compartir <i class="fas fa-share-alt"></i></a>
                </div-->
              </div>
            </div>

            <div class="col-12 col-info">
              
              <div class="row row-body">
                <div class="col col-detail">
                  Ingresos totales brutos:
                </div>
                <div class="col col-med">
                  {{detailInfo.ingresos_bruto}}
                </div>
              </div>

              <div class="row row-body">
                <div class="col col-detail">
                  Ingresos gravados totales:
                </div>
                <div class="col col-med">
                  {{detailInfo.ingresos_gravados_totales}}
                </div>
              </div>

              <div class="row row-body">
                <div class="col col-detail">
                  ISR a retener en el mes (o subsidio al empleo):
                </div>
                <div class="col col-med">
                  {{detailInfo.isr_ingreso_gravados}}
                </div>
              </div>

              <div class="row row-body">
                <div class="col col-detail">
                  Ingreso neto a recibir según mecánica conforme al artículo <span style="font-size: 15px;font-weight: 400;position: relative;bottom: 3px;">9</span>6 del ISR:
                </div>
                <div class="col col-med">
                  {{detailInfo.ingreso_neto_recibir}}
                </div>
              </div>

              <div class="row row-body">
                <div class="col col-detail">
                  Impuesto a retener por aguinaldo según mecánica conforme al artículo <span style="font-size: 19px;font-weight: 300;position: relative;bottom: 0px;">1</span><span style="font-size: 16px;font-weight: 400;position: relative;bottom: 1.4px;">7</span><span style="font-size: 16px;font-weight: 400;position: relative;bottom: 2px;">4</span> del RISR:
                </div>
                <div class="col col-med">
                  {{detailInfo.impuesto_aretener}}
                </div>
              </div>

              <div class="row row-body">
                <div class="col col-detail">
                  ISR a retener en el mes (o subsidio al empleo)</span>:
                </div>
                <div class="col col-med">
                  {{detailInfo.isr_retener_mes}}
                </div>
              </div>

              <div class="row row-body">
                <div class="col col-detail">
                  Ingreso neto a recibir según mecánica conforme al artículo <span style="font-size: 19px;font-weight: 300;position: relative;bottom: 0px;">1</span><span style="font-size: 16px;font-weight: 400;position: relative;bottom: 1.4px;">7</span><span style="font-size: 16px;font-weight: 400;position: relative;bottom: 2px;">4</span> del RISR:
                </div>
                <div class="col col-med">
                  {{detailInfo.ingreso_neto_recibir_dos}}
                </div>
              </div>

            </div>
            <div class="col-12 col-options">
              <p class="mb-3">
                <a type="button" class="btn _btn-st1" :href="detailInfo.links.excel" target="_blank">Exportar a Excel</a>
                <a type="button" class="btn _btn-st1" :href="detailInfo.links.pdf" target="_blank">Exportar a PDF</a>
              </p>
              <p>
                <b-button type="submit" class="_btn-st1 btn-orange" @click="otherCalc">Hacer otro cálculo</b-button>
              </p>
            </div>

           
          </div>
        </div>
        <!-- Paso 2, FIN -->
        <!-- Fundamentos legales -->
        <flegales-component id="table-flegales"></flegales-component>
        <!--  -->
      </div>
    </section>


    <!-- ******** Modals ******** -->
    <!-- Modal "Compartir a Correo" -->
    <b-modal id="modal-compartir" ref="modal-compartir" hide-footer hide-header centered no-close-on-backdrop no-close-on-esc modal-class="modal-st-1">
      <b-form class="content" @submit="onSubmitComp">
        <div class="box-content">
          <h5 class="title">Escribe el correo a compartir</h5>

          <b-form-group class="custom-form-group"
            label="Correo"
            label-for="il-email">
            <b-form-input
              id="il-email"
              v-model="formComp.email"
              type="email"
              placeholder="correo@ejemplo.com"
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="box-footer">
          <button type="button" class="btn _btn-st1" @click="$refs['modal-compartir'].hide()">Cancelar</button>
          <b-button type="submit" class="_btn-st1 btn-orange">Compartir</b-button>
        </div>
      </b-form>
    </b-modal>
    <!--  -->

    <!-- Modal "Guardar calculo" -->
    <b-modal id="modal-gcalculo" ref="modal-gcalculo" hide-footer hide-header centered no-close-on-backdrop no-close-on-esc modal-class="modal-st-1">
      <b-form class="content" @submit="onSubmitCalc">
        <div class="text-center box-content">
          <i class="fal fa-check-circle icon-success"></i>
          <h5 class="title">¡Cálculo guardado con éxito!</h5>
        </div>

        <div class="box-footer">
          <router-link type="button" class="btn _btn-st1" to="/catalogos">Salir</router-link>
          <b-button type="submit" class="_btn-st1 btn-orange">Hacer otro cálculo</b-button>
        </div>
      </b-form>
    </b-modal>
    <!--  -->

    <!--  -->
    <b-modal id="modal-loading" ref="modal-loading" hide-footer hide-header centered no-close-on-backdrop no-close-on-esc modal-class="modal-st-1">
        <div style="text-align: center;">
          <img src="public/images/shared/loading.gif">
          <br><br><h3>Realizando cálculo</h3>
        </div>
    </b-modal>

  </div>
</template>

<script>
  import FlegalesComponent from './components/fleg-comp-isr-pago-de-aginaldo.vue';
export default {
  data(){
    return{
      showFLegalesComp: false,
      step: 1,

      form: {
        anio: null,
      },

      formComp: {
        email: null
      },
      years:[],
      detailInfo:{

      },
      validation:{
        salario:null,
        aguinaldo:null
      }
    }
  },

  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    onSubmit(event) { // Enviar formulario del paso 1
      this.validation.aguinaldo = null;
      this.validation.salario = null;
      
      event.preventDefault();
      if (this.form.aguinaldo == 0 || this.form.aguinaldo == null) {
          this.validation.aguinaldo = '"Aguinaldo a pagar" debe de ser mayor a 0';
          return;
      }
      if (this.form.salario == 0 || this.form.salario == null) {
          this.validation.salario = '"Salario mensual ordinario" debe de ser mayor a 0';
          return;
      }

        this.$refs['modal-loading'].show();
        //$('#btn_calc').hide();
        event.preventDefault();
        axios.post(tools.url("/calculateFour"),this.form).then((response)=>{
            this.detailInfo = response.data;
            this.$refs['modal-loading'].hide();
            this.step = 2;
        }).catch((error)=>{
            $('#btn_calc').show();
            this.$refs['modal-loading'].hide();
            alert('Ocurrio un error al calcular la informacion');
        });
    },

    onSubmitComp(event) { // Enviar formulario compartir del Modal "Compartir a Correo"
      event.preventDefault();
      this.$refs['modal-compartir'].hide();

      console.log("Compartir cálculo");
    },

    onSubmitCalc(event) { // Guardar cálculo y regresar a paso 1
      event.preventDefault();

       

      var keys = Object.keys(this.form);
      var resetForm = {};
      keys.forEach(key => resetForm[key] = null);
      this.form = resetForm;

      this.step = 1;
      this.$refs['modal-gcalculo'].hide();

      console.log("Hacer otro cálculo");
    },
    otherCalc(){
      location.reload();
    },
    scrolltoTable(){
      var tablePosY = document.getElementById("table-flegales").offsetTop;
      this.showFLegalesComp = true;

      setTimeout( ()=>{
        window.scrollTo({ top: tablePosY, left: 0, behavior: 'smooth' });
      }, 200);
    },
  },

  mounted(){
      var fecha = new Date();
      var anio = fecha.getFullYear();
      var years = [];
      for (var i = 2016; i <= anio; i++) {
          var aux = {
            'value':i
          };
          years.push(aux);
      }

      years.reverse();
      this.years = years;
  },
  components: {
    FlegalesComponent
  },
}
</script>
